import { noop } from 'lodash';
import React from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { IconType } from '~/eds/src/types/IconType';

type Props = {
  value: 'and' | 'or';
  icon?: IconType;
};
export const Operator = ({ value, icon }: Props) => {
  const intl = useIntl();
  return (
    <Layout
      onClick={noop}
      border="border"
      borderRadius="m"
      px={2}
      align="center"
      styles={{ height: 'filter.height', userSelect: 'none' }}
    >
      <Text>
        {value === 'and'
          ? intl.formatMessage({
              id: 'Operator.and',
              defaultMessage: 'AND',
              description: 'Logical AND operator',
            })
          : intl.formatMessage({
              id: 'Operator.or',
              defaultMessage: 'OR',
              description: 'Logical OR operator',
            })}
      </Text>
      {icon && <Icon icon={icon} />}
    </Layout>
  );
};
